const Order = require('@/lib/Orders/Order');
const OrderAdjustmentResponse = require('@/libraries/DigiTickets/Orders/Adjustments/OrderAdjustmentResponse');
const Payment = require('@/lib/Payments/Payment');
const { toString } = require('@/functions/transform');

class CheckoutResult {
    /**
     * @see {import('@/lib/Checkout/CheckoutType')}
     * @type {string}
     */
    checkoutType = '';

    /**
     * @type {Order}
     */
    order = null;

    /**
     * @type {OrderAdjustmentResponse|null}
     */
    orderAdjustmentResponse = null;

    /**
     * Array of new payments that were taken during this checkout.
     *
     * @type {Payment[]}
     */
    newPayments = [];

    constructor(
        checkoutType,
        order,
        orderAdjustmentResponse = null
    ) {
        this.checkoutType = checkoutType;
        this.order = order;
        this.orderAdjustmentResponse = orderAdjustmentResponse;
    }

    /**
     * @param {Payment[]} newPayments
     */
    setNewPayments(newPayments) {
        this.newPayments = newPayments;
    }

    wasOffline() {
        return !this.order.bookingRef;
    }

    getHydrationMap() {
        return {
            checkoutType: toString,
            order: {
                model: Order,
            },
            orderAdjustmentResponse: {
                model: OrderAdjustmentResponse,
            },
            newPayments: {
                modelCollection: Payment,
            },
        };
    }
}

module.exports = CheckoutResult;
